<script lang="ts" setup>
const props = defineProps({
  answer: {
    required: true,
    type: String,
  },
  icon: {
    default: '',
    type: String,
  },
  keepOpened: {
    default: false,
    type: Boolean,
  },
  question: {
    required: true,
    type: String,
  },
})

const opened = ref(props.keepOpened)

function onClick() {
  if (!props.keepOpened) {
    opened.value = !opened.value
  }
}
</script>

<template>
  <div
    class="gradient-texture-light w-full overflow-hidden rounded-xl bg-gray-100 p-5 text-left shadow-sm outline-none ring-1 ring-gray-200 md:p-6 dark:bg-gray-900 dark:ring-gray-800"
    :class="{
      'cursor-pointer transition duration-200 hover:shadow-none hover:ring-gray-300 dark:hover:ring-gray-700': !keepOpened,
    }"
    @click="onClick"
  >
    <div class="flex items-center">
      <span class="hidden md:inline-flex">
        <UIcon
          v-if="icon"
          class="mr-4 mt-0.5 size-7 flex-shrink-0"
          :name="icon"
        />
      </span>

      <p class="mr-4 flex-1 select-none text-lg font-semibold md:text-xl">
        {{ question }}
      </p>

      <UIcon
        v-if="!keepOpened"
        class="mr-1 mt-1 size-6 flex-shrink-0 transform transition-transform duration-200"
        :class="{ 'rotate-90': opened }"
        :name="getIcon('chevronRight')"
      />
    </div>

    <p
      v-show="opened"
      class="mt-4 text-gray-600 md:text-lg dark:text-gray-400"
      size="lg"
    >
      {{ answer }}
    </p>
  </div>
</template>
